import React from 'react';
import Categories from '../../components/Categories';
import SubCategories from '../../components/SubCategories';
import AddCategoryWrapper from '../../components/AddCategory';

const ManageCategoriesPage = ({ classes }) => {
  return (
    <div className={`${classes.wrap} categories`}>
      <div className={classes.categories}>
        <Categories />
        {/* <br></br> */}
        <SubCategories />
      </div>
      <div className={classes.addCategories}>
        {/* <AddCategoryWrapper/> */}
      </div>
    </div>
  );
};

export default ManageCategoriesPage;
